var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.adobeTargetExperience === 'AR2024CNOMV2')?_c('consultaV2'):_c('consulta')
}
var staticRenderFns = []

export { render, staticRenderFns }